import { render, staticRenderFns } from "./wrapper.vue?vue&type=template&id=7473887e&"
import script from "./wrapper.vue?vue&type=script&lang=js&"
export * from "./wrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7473887e')) {
      api.createRecord('7473887e', component.options)
    } else {
      api.reload('7473887e', component.options)
    }
    module.hot.accept("./wrapper.vue?vue&type=template&id=7473887e&", function () {
      api.rerender('7473887e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/collapse/wrapper.vue"
export default component.exports